const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {
}

export const actions = {
  async getCommCenterToken(){
    let result = null;
    try {
      result = await this.$axios.get('commcenter/get-comm-center-embed-token');
      return result?.data;
    }
    catch (error) {
      console.error("Error while getting CommCenter token.", error);
      this.$toast.error("Error while retrieving CommCenter token.");
    }
    return null;
  },
  async getCommCenterBaseUrl(){
    let result = null;

    try{
      result = await this.$axios.get('commcenter/get-comm-base-url');
    }
    catch (error) {
      console.error("Error while getting CommCenterBaseUrl.", error);
      this.$toast.error("Error while connecting to CommCenter.");
    }

    return result;
  }
}
